import React, { useState } from 'react';
import { Loader } from 'semantic-ui-react';
import StandaloneMenu from '../../components/Menu/Menu-standalone';
import { useFacility } from '../../contexts/facility/FacilityContext';
import MenuDining from '../../components/Menu/Menu-dining';
import "./style.less";
import "./dining-shell.less";

const Menu = () => {
    const { facilityDetails, facilityTimezone } = useFacility();
    const [loadingMenu, setLoadingMenu] = useState<boolean>(false);
    const diningView = !!(facilityDetails?.featureConfigs?.configurations?.dining);

    if (diningView) {
        return <MenuDining facilityTimezone={facilityTimezone} />;
    }

    return (
        <div className="menu-standalone-shell">
            {loadingMenu && (
                <div className="menu-standalone-loading" role="status" aria-live="polite">
                    <Loader active inline="centered" content="Loading Menu" />
                </div>
            )}
            <StandaloneMenu setLoadingMenu={setLoadingMenu} facilityTimezone={facilityTimezone} />
        </div>
    );
};

export default Menu;
